/**
 * How this person's address box offers a building's entrances (#420): their own choice from
 * the person menu, or the firm's when they made none.
 *
 * Apart from `EntrancesSelect` for the reason `preferencesContext.ts` gives: a module that
 * exports a component and a hook cannot be fast-refreshed.
 */

import { usePlacesFeatures } from '../places/features';
import { usePreferences } from './preferencesContext';

/** The way this person's address box offers entrances: their own choice, or the firm's. */
export function useEntranceWay(): 'list' | 'after' {
  const { current } = usePreferences();
  const firm = usePlacesFeatures();

  return current.entrances ?? (firm.entrancesAfterAddress ? 'after' : 'list');
}
